import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./common/BackToTop";
import { Styles } from "./styles/footerOne.js";
import useSiteContent from "../hooks/useSiteContent";

function Footer() {
  const footer = useSiteContent("footer");

  return (
    <Styles>
      {/* Footer Area */}
      <footer
        className="footer1"
        style={{
          backgroundImage: footer.backgroundImage
            ? `url(${process.env.PUBLIC_URL}/assets/images/${footer.backgroundImage})`
            : undefined,
        }}
      >
        <Container>
          <Row>
            <Col md="4">
              <div className="footer-logo-info">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                  alt="Swiss School"
                  className="img-fluid"
                />
                <p>{footer.description}</p>
                <ul className="list-unstyled">
                  <li>
                    <i className="las la-map-marker"></i>
                    {footer.address}
                  </li>
                  <li>
                    <i className="las la-envelope"></i>
                    {footer.email}
                  </li>
                  <li>
                    <i className="las la-phone"></i>
                    {footer.phone}
                  </li>
                </ul>
              </div>
            </Col>
            <Col md="4">
              <div className="f-links">
                <h5>{footer.quickLinksTitle}</h5>
                <ul className="list-unstyled">
                  {(footer.quickLinks || []).map((link) => (
                    <li key={link.url}>
                      <Link to={process.env.PUBLIC_URL + link.url}>
                        <i className="las la-angle-right"></i>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col md="4">
              <div className="f-post">
                <h5>Recent Resources</h5>
                <div className="post-box d-flex">
                  <div className="post-img">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/blog-2.jpg"
                      }
                      alt=""
                    />
                  </div>
                  <div className="post-content">
                    <Link to={process.env.PUBLIC_URL + "/blog-details"}>
                      How to choose the right study destination
                    </Link>
                    <span>Jul 22, 2024</span>
                  </div>
                </div>
                <div className="post-box d-flex">
                  <div className="post-img">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/blog-3.jpg"
                      }
                      alt=""
                    />
                  </div>
                  <div className="post-content">
                    <Link to={process.env.PUBLIC_URL + "/blog-details"}>
                      Funding options for international students
                    </Link>
                    <span>Jun 15, 2024</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* Copyright Area */}
      <section className="copyright-area">
        <Container>
          <Row>
            <Col md="6">
              <div className="copy-text">
                <p>
                  Copyright &copy; {new Date().getFullYear()} |{" "}
                  {footer.copyright}
                </p>
              </div>
            </Col>
            <Col md="6" className="text-right">
              <span className="footer-contact">
                {footer.helpText}{" "}
                <a href={`mailto:${footer.email}`}>{footer.email}</a>
              </span>
            </Col>
          </Row>
        </Container>

        {/* Back To Top */}
        <BackToTop />
      </section>
    </Styles>
  );
}

export default Footer;
